import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const hidden = css`
  display: none;
`;

export const filtersButton = css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-left: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const filterIconButton = css`
  height: 2.5rem;
  width: 2.5rem;
  margin-left: 1rem;
`;

export const filterIcon = css`
  height: 1rem;
  margin: 0 0.75rem;
`;

export const activeFilterButton = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMutedHover};
  border-color: ${theme.system.borderActive};
  color: ${theme.system.textLabelEmphasis};
`;

export const inActiveTextFilterButton = css`
  min-width: 150px;
`;
